"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDifferenceFromTodaysDate = exports.NOW_DATE = void 0;
const fp_1 = require("date-fns/fp");
exports.NOW_DATE = new Date();
const calculateDifferenceFromTodaysDate = (date, dateFormat = 'M/d/yyyy h:mm:ss a') => {
    try {
        const difference = (0, fp_1.differenceInHours)(date)(exports.NOW_DATE);
        if (difference < 1) {
            if ((0, fp_1.differenceInMinutes)(date)(exports.NOW_DATE) < 0) {
                return '0min';
            }
            return `${(0, fp_1.differenceInMinutes)(date)(exports.NOW_DATE)}min`;
        }
        if (difference < 24) {
            return `${(0, fp_1.differenceInHours)(date)(exports.NOW_DATE)}h`;
        }
        if (difference < 168) {
            return `${(0, fp_1.differenceInDays)(date)(exports.NOW_DATE)}d`;
        }
        if (difference <= 672) {
            return `${(0, fp_1.differenceInWeeks)(date)(exports.NOW_DATE)}w`;
        }
        return (0, fp_1.format)(dateFormat, date);
    }
    catch (err) {
        return 'ERROR';
    }
};
exports.calculateDifferenceFromTodaysDate = calculateDifferenceFromTodaysDate;
